var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"skeleton--container"},[_c('div',{staticClass:"left--skeleton"},[_c('page-select')],1),_c('div',{staticClass:"right--skeleton",staticStyle:{"position":"relative"}},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }